interface TowerIconProps {
  color?: string
  width?: number
  height?: number
  style?: React.CSSProperties
}

const TowerIcon = ({
  color = "white",
  width = 15,
  height = 15,
  style,
}: TowerIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        fill={color}
        d="m492.303 482h-43.912l-110.97-322.373h130.542v30.068c0 8.284 6.716 15 15 15s15-6.716 15-15v-45.068c0-4.637-2.145-9.014-5.81-11.855l-164.125-127.233c-2.751-3.378-6.939-5.539-11.635-5.539-.098 0-.193.013-.29.015-.118-.003-.235-.015-.353-.015h-119.741c-.074 0-.147.008-.22.009-.062-.001-.121-.009-.182-.009-4.411 0-8.365 1.916-11.109 4.947l-164.658 127.832c-3.66 2.842-5.802 7.215-5.802 11.849v45.068c0 8.284 6.716 15 15 15s15-6.716 15-15v-30.068h130.542l-110.971 322.372h-43.912c-8.284 0-15 6.716-15 15s6.716 15 15 15h54.594.014 363.39.014 54.594c8.284 0 15-6.716 15-15s-6.715-15-15-15zm-89.939-41.54-125.151-125.15 61.053-61.053zm-191.757-310.833v-99.627h90.786v99.627zm-30 0h-107.787l107.787-83.68zm150.786-83.52 107.738 83.52h-107.738zm-25.7 113.52 21.71 63.068-71.403 71.402-66.427-66.426c-1.605-1.605-3.488-2.755-5.491-3.48l22.225-64.563h99.386zm-131.959 94.629 61.054 61.054-125.152 125.15zm82.266 82.267 145.477 145.477h-290.954z"
      />
    </svg>
  )
}

export default TowerIcon
